/** Au-dessus des modales DynamicDialog (baseZIndex 1100 + empilement auto). */
export const APP_DRAWER_BASE_Z_INDEX = 1300;
/** Animation de fermeture PrimeNG drawer (0.5s) + marge masque. */
export const APP_DRAWER_CLOSE_ANIMATION_MS = 600;

export function buildDrawerStyleClass(dialogClass?: string): string {
	return ['app-dynamic-drawer', dialogClass].filter(Boolean).join(' ');
}
